import { render, staticRenderFns } from "./WGSpinnerModal.vue?vue&type=template&id=19be06c1&scoped=true&"
import script from "./WGSpinnerModal.vue?vue&type=script&lang=js&"
export * from "./WGSpinnerModal.vue?vue&type=script&lang=js&"
import style0 from "./WGSpinnerModal.vue?vue&type=style&index=0&id=19be06c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../tasks/spa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19be06c1",
  null
  
)

export default component.exports